import React, { useState } from "react";
import styled from "styled-components";
import { DropdownMenuComponents } from "@common/LifeAtDropdownMenuV2/DropdownMenuComponents";
import { FontSize } from "@themes/Fonts";
import { useTagAssignmentInput } from "../planner/useTagAssignmentInput";
import TagComponent from "./TagComponent";
import { TagAssignmentDropdownContent } from "./TaskTagAssignmentDropdownComponents";

const StyledTagComponent = styled(TagComponent)`
    font-size: ${FontSize.normal};
`;
interface TagAssignmentDropdownProps {
    /**
     * TagId of the current task. If the task has no tagId, selectedTagId is
     * undefined and the unassigned tag will be displayed as the current tag
     */
    readonly selectedTagId?: string;
    readonly updateTaskTag: (tagId: string | null) => Promise<void>;
    readonly onAssign: (tagId: string) => void;
    readonly onRemove: () => void;
}
export function TagAssignmentDropdown(props: TagAssignmentDropdownProps) {
    const [isTagPopoverOpen, setIsTagPopoverOpen] = useState(false);

    const [selectedTagId, setSelectedTagId, selectedTag] = useTagAssignmentInput({
        taskTagId: props.selectedTagId,
        updateTaskTag: props.updateTaskTag,
        onAssign: props.onAssign,
        onRemove: props.onRemove,
    });

    return (
        <DropdownMenuComponents.Root
            open={isTagPopoverOpen}
            onOpenChange={(open: boolean) => setIsTagPopoverOpen(open)}
        >
            <DropdownMenuComponents.Trigger>
                <StyledTagComponent tag={selectedTag} />
            </DropdownMenuComponents.Trigger>
            <DropdownMenuComponents.Content>
                <TagAssignmentDropdownContent
                    selectedTagId={selectedTagId}
                    handleTagUpdate={(tagId: string) => {
                        setSelectedTagId(tagId);
                        setIsTagPopoverOpen(false);
                    }}
                />
            </DropdownMenuComponents.Content>
        </DropdownMenuComponents.Root>
    );
}
